import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  RegionalAddr,
  StyledPlaceName,
  StyledSecondaryAddr,
} from 'emergency_data/src/components/JurisdictionView/UniversalSearch/ConnectedUniversalSearch.styles';
import { reset } from 'emergency_data/src/components/JurisdictionView/UniversalSearch/searchSlice';
import { EarthSearchIcon, XCloseIcon } from '@rsos/assets/icons';
import Box from '@rsos/components/capstone/base/Box';
import Text from '@rsos/components/capstone/base/Text';
import { hidePinnedPopover } from '@rsos/components/capstone/common/Map/useDeckGL/MapPopover/mapPopoverSlice';
import { clearSelectedLocation } from '@rsos/reduxDataStore/src/features/gisSearch/gisSearchSlice';
import { IconWrapper } from './MapPopover.styles';

const PinnedMapPopoverHeader = ({
  location,
  isGlobalFormat,
  isGlobalSource,
}) => {
  const dispatch = useDispatch();

  const {
    PlaceName,
    StAddr,
    SubAddr,
    City,
    RegionAbbr,
    Postal,
    MetroArea,
    Region,
    Zone,
  } = location?.attributes;

  let regionalAdd = `${MetroArea}, ${Region} ${Zone}`;
  if (isGlobalFormat) {
    regionalAdd = `${City}, ${RegionAbbr} ${Postal}`;
    if (!City) {
      regionalAdd = `${RegionAbbr} ${Postal}`;
    }
  } else {
    if (!MetroArea) {
      regionalAdd = `${Region} ${Zone}`;
    }
  }
  const close = useCallback(() => {
    dispatch(reset());
    dispatch(clearSelectedLocation());
    dispatch(hidePinnedPopover());
  }, [dispatch]);

  return (
    <Box>
      <IconWrapper horizontal pointer alignSelf="end">
        <XCloseIcon width="12px" height="12px" onClick={close} />
      </IconWrapper>
      {PlaceName && (
        <StyledPlaceName isPinnedPopover ellipsis>
          {PlaceName}
        </StyledPlaceName>
      )}
      {StAddr && (
        <StyledSecondaryAddr isPinnedPopover isPrimary={!PlaceName} ellipsis>
          {StAddr}
        </StyledSecondaryAddr>
      )}

      {SubAddr && (
        <StyledSecondaryAddr isPinnedPopover isPrimary={!PlaceName && !StAddr}>
          {SubAddr}
        </StyledSecondaryAddr>
      )}

      <RegionalAddr isPinnedPopover size="small" color="secondaryText" ellipsis>
        {regionalAdd}
      </RegionalAddr>

      <Box horizontal pt={2} m="0">
        <IconWrapper pr={1} justify="center">
          <EarthSearchIcon width="12px" height="12px" />
        </IconWrapper>
        <Text size="normal" color="secondaryText" ellipsis>
          {isGlobalSource ? 'Global Basemap' : 'Local Basemap'}
        </Text>
      </Box>
    </Box>
  );
};

export default PinnedMapPopoverHeader;
